import React from "react";
import { useAskWaiting } from "../../hooks/useAskWaiting";
import { resumeAsk, waitingNote } from "../../utils/askReturn";
import classes from "./assistant.module.scss";

/**
 * "Ask CRX · 1 waiting" in the header, only while Ask waits on an answer with
 * steps left (2026-10-15): it opens that same answer, so nobody starts the
 * conversation again from somewhere else. No AI credit is used.
 */
const AskWaitingButton: React.FC = () => {
    const { waiting } = useAskWaiting();
    if (!waiting) return null;
    return (
        <button type="button" className={`btn-unstyled ${classes.waitingButton}`} onClick={resumeAsk}
            title={`Ask is waiting${waiting.title ? ` on “${waiting.title}”` : ""} — ${waitingNote(waiting)}. Opens the same answer, not a new chat. No AI credit used.`}>
            <i className="bi bi-stars" aria-hidden="true" />
            Ask CRX
            <span className={classes.waitingBadge}>1 waiting</span>
        </button>
    );
};

export default AskWaitingButton;
